import React, { Fragment, useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert, Alert as MuiAlert, AlertTitle } from "@material-ui/lab";
import message from "src/utils/message";

const GlobalSnackbars = () => {
	const [isOpen, setOpen] = useState(false);
	const [severity, setSeverity] = useState("info");
	const [content, setContent] = useState("");
	const [option, setOption] = useState({});

	const handleClose = (_, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setOpen(false);
	};
	useEffect(() => {
		message.info = (msg, option) => {
			setOpen(true);
			setSeverity("info");
			setContent(msg);
			if (option) setOption(option);
		};
		message.warn = (msg, option) => {
			setOpen(true);
			setSeverity("warn");
			setContent(msg);
			if (option) setOption(option);
		};
		message.success = (msg, option) => {
			setOpen(true);
			setSeverity("success");
			setContent(msg);
			if (option) setOption(option);
		};
		message.error = (msg, option) => {
			setOpen(true);
			setSeverity("error");
			setContent(msg);
			if (option) setOption(option);
		};
	}, []);

	return (
		<Fragment>
			<Snackbar
				open={isOpen}
				autoHideDuration={option?.duration ?? 5000}
				onClose={handleClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert onClose={handleClose} severity={severity}>
					{content}
				</Alert>
			</Snackbar>
		</Fragment>
	);
};

export default GlobalSnackbars;
